import Reflux from 'reflux';

var SearchActions = Reflux.createActions([
    'search',
    'cleanSearch',
    'getUserSuggestions',
    'filterResultsFollowing'
]);

export default SearchActions;



// WEBPACK FOOTER //
// ./src/actions/SearchActions.js